export const SOCIAL_SHARE_SOURCE_CONTRACT = {
  sourceRelease: "0.0.81",
  surface: "desktop-social-share-modal",
  title: "Share to socials",
  previewAlt: "Blender Bridge scene",
  actions: {
    save: "Save image",
    copy: "Copy image",
    other: "Other ways",
  },
  nativeShareCondition: "macOS ShareMenu",
  hint: "Share your scene on X, Telegram, Instagram or Reddit.",
  platforms: ["X", "Telegram", "Instagram", "Reddit"],
  statuses: {
    preparing: "Preparing scene…",
    saved: "Image saved",
    copied: "Screenshot copied",
    opened: "Share window opened",
    failed: "Could not prepare the scene",
    nativeUnavailable: "System share is unavailable",
  },
  geometry: {
    panelWidthPx: 604,
    viewportInsetPx: 48,
    paddingPx: [24, 26, 22],
    previewMaxHeightPx: 440,
    platformDiameterPx: 46,
  },
} as const;

export const SOCIAL_SHARE_PLATFORM_IDS = ["x", "telegram", "instagram", "reddit"] as const;
export type SocialSharePlatform = (typeof SOCIAL_SHARE_PLATFORM_IDS)[number];

export type SocialSharePlatformOutcomeKind =
  | "telegram-desktop-file-launch-caption-copy"
  | "copy-image-open-composer"
  | "copy-image-open-instagram-home";

export interface SocialSharePlatformOutcome {
  readonly label: string;
  readonly kind: SocialSharePlatformOutcomeKind;
  readonly description: string;
  readonly automaticallyPublishes: false;
}

export const SOCIAL_SHARE_PLATFORM_OUTCOMES: Readonly<Record<SocialSharePlatform, SocialSharePlatformOutcome>> = {
  x: {
    label: "X",
    kind: "copy-image-open-composer",
    description: "Изображение копируется; затем открывается окно публикации X.",
    automaticallyPublishes: false,
  },
  telegram: {
    label: "Telegram",
    kind: "telegram-desktop-file-launch-caption-copy",
    description: "Файл открывается в Telegram Desktop; подпись отдельно копируется в буфер обмена.",
    automaticallyPublishes: false,
  },
  instagram: {
    label: "Instagram",
    kind: "copy-image-open-instagram-home",
    description: "Изображение копируется; затем открывается instagram.com.",
    automaticallyPublishes: false,
  },
  reddit: {
    label: "Reddit",
    kind: "copy-image-open-composer",
    description: "Изображение копируется; затем открывается форма публикации изображения Reddit.",
    automaticallyPublishes: false,
  },
};
